import axios from 'axios'
import { reactLocalStorage } from 'reactjs-localstorage'

let headers = {}

let BACKEND_URL = 'https://qa-vendor-api.gettoindia.com/api/v1'
const domain = window.location.origin

if (domain == 'https://getto.aventusinformatics.com') {
  // BACKEND_URL='https://zync-api.zaparetech.com/api';
  BACKEND_URL = 'https://qa-vendor-api.gettoindia.com/api/v1'
} else if (domain == 'https://vendor.gettoindia.com') {
  BACKEND_URL = 'https://vendor-api.gettoindia.com/api/v1'
} else if (domain.includes('localhost')) {
  console.log('Localhost detected, using local backend URL')
  // BACKEND_URL = 'https://qa-vendor-api.gettoindia.com/api/v1'
  BACKEND_URL = 'http://localhost:3030/api/v1' // ✅ Local backend for development
  //  BACKEND_URL = 'https://6b3a-2401-4900-889d-23f6-a86d-88a8-e595-f53b.ngrok-free.app/api/v1'; // ✅ Local backend for development with ngrok
} else {
  BACKEND_URL = 'https://qa-vendor-api.gettoindia.com/api/v1'
}
// const BACKEND_URL = 'https://qa-vendor-api.gettoindia.com/api/v1'

const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  headers,
})

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = reactLocalStorage.get('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      // console.log('Bearer Token found and set in headers:', token)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response)
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }

    if (error.response.status === 403) {
    } else {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }
  }
)

export default axiosInstance
